import { useState, useEffect } from 'react'
import { apiUrl } from './utils'
import { IdoorAccess } from './types'

export function useGetRoomsList() {
  const [items, setItems] = useState<IdoorAccess[]>([])
  useEffect(() => {
    async function fetchData() {
      var data = await fetch(apiUrl + 'userAPI.php?controller=doorAccessController&method=getList').then((res) => {
        return res.json()
      })
      setItems(data)
    }
    fetchData()
  }, [])

  return items
}

export function useGetRoomsListByRoomsId(roomsListId: string) {
  const [items, setItems] = useState<IdoorAccess[]>([])
  useEffect(() => {
    async function fetchData() {
      var data = await fetch(apiUrl + 'userAPI.php?controller=doorAccessController&method=getRoomsList', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ roomsListId }),
      }).then((res) => {
        return res.json()
      })
      setItems(data)
    }
    fetchData()
  }, [roomsListId])

  return items
}

export function useGetRoomsListById(id: string) {
  const [items, setItems] = useState<IdoorAccess>()
  useEffect(() => {
    async function fetchData() {
      var data = await fetch(apiUrl + 'userAPI.php?controller=doorAccessController&method=getById', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id }),
      }).then((res) => {
        return res.json()
      })
      setItems(data)
    }
    fetchData()
  }, [id])

  return items
}

export async function UseRoomsListCreate(json: IdoorAccess) {
  async function fetchData() {
    var data: IdoorAccess = await fetch(apiUrl + 'userAPI.php?controller=doorAccessController&method=add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(json),
    }).then((res) => {
      return res.json()
    })
    return data
  }
  return fetchData()
}

export async function UseRoomsLisUpdate(json: IdoorAccess) {
  async function fetchData() {
    var data: IdoorAccess = await fetch(apiUrl + 'userAPI.php?controller=doorAccessController&method=update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(json),
    }).then((res) => {
      return res.json()
    })
    return data
  }
  return fetchData()
}

export async function UseRoomsLisDelete(id: string) {
  async function fetchData() {
    var data: IdoorAccess = await fetch(apiUrl + 'userAPI.php?controller=doorAccessController&method=delete', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id }),
    }).then((res) => {
      return res.json()
    })
    return data
  }
  return fetchData()
}
